import { render } from "@variocube/app-common";
export function classNames(...classNames) {
    return classNames.filter(className => !!className).join(' ');
}
export function ensureReactRoot(id) {
    let reactRoot = document.getElementById(id);
    if (!reactRoot) {
        reactRoot = document.createElement('div');
        reactRoot.id = id;
        reactRoot.className = "react-root";
        document.body.appendChild(reactRoot);
    }
    return reactRoot;
}
export function toT(strings) {
    return typeof strings == "function" ? strings : (key, view) => render(strings[key], view !== null && view !== void 0 ? view : {});
}
//# sourceMappingURL=utils.js.map